import React from "react";
import { IconBaseProps } from "react-icons";

export const PasswordSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 26 26"
        fill={fill}
        fillRule="evenodd"
        display="block"
    >
      <path d="M5.337 17.845l2.548-2.548-2.722-2.722-2.548 2.548 2.722 2.722zm8.883-3.241a6.215 6.215 0 0 1-2.4-2.4l-7.572 7.571 2.4 2.4 7.572-7.571zm4.948-3.563a2.658 2.658 0 0 1-3.76 0c-1.065-1.064-1.065-2.747-.025-3.786 1.039-1.04 2.721-1.04 3.785.024a2.658 2.658 0 0 1 0 3.762zm2.104 2.103a5.63 5.63 0 0 0 0-7.968c-2.227-2.227-5.79-2.227-7.993-.024-2.202 2.202-2.202 5.765.025 7.992a5.63 5.63 0 0 0 7.968 0z"/>
    </svg>
);
